// extracted by mini-css-extract-plugin
module.exports = {"root":"Chip_root__s19al","selected":"Chip_selected__1Juxg"};